import React from 'react';
import { Link as RouterLink, To } from 'react-router-dom';

import { Dropdown, DropdownOption } from '~/components/Dropdown';
import { LogoHeader } from '~/components/LogoHeader';
import { useMarketParam } from '~/contexts/UrlParamsContext';
import { useJiraConfigQuery } from '~/hooks/useJiraConfigQuery';
import { RequestsPageUrl } from '~/pages/urls';

export const RequestsHeader: React.FC = () => {
  const market = useMarketParam();
  const { data: config, isLoading } = useJiraConfigQuery();
  const markets = config?.fields?.reviewRegion?.allowedValues || [{ value: market }];
  const currentSelection = markets?.find(m => m.value === market)?.value || '';

  return (
    <LogoHeader>
      <Dropdown
        dark
        name="market"
        value={currentSelection}
        isLoading={isLoading}
        sx={{ ml: '30px', minWidth: '200px' }}
      >
        {markets.map((market) => {
          const { value } = market;
          return (
            <DropdownOption
              key={value}
              value={value}
              to={RequestsPageUrl.expand({ market: value })}
              component={
                RouterLink as React.FC<{
                  value: string;
                  to: To;
                }> as React.ElementType
              }
            >
              {value}
            </DropdownOption>
          )
        })}
      </Dropdown>
    </LogoHeader>
  );
};
